import { useSelector } from 'react-redux';

const useCustomSelector = (selectorFunction) => {
    return useSelector(selectorFunction);
};

export default useCustomSelector;
